import './style.css'
const HeroSection = () => {

    return (
        <section className='hero-section' id="start"
        >
           <h1>JAIANNY <small>&</small> FELIPE</h1>
           <h2>11.10.2026</h2>
        </section>
    );
};

export default HeroSection;